import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";

import styles from "./Navbar.module.css";

export default function Navbar(props) {
  const [menuOpen, setMenuOpen] = useState(false);
  const menu = useRef();
  const menuToggleButton = useRef();

  const onNavbarToggleButtonClick = (e) => {
    if (menuOpen === false) {
      menu.current.classList.add(styles.open);
      menuToggleButton.current.classList.add(styles.open);
      setMenuOpen(true);
    }
    if (menuOpen === true) {
      menu.current.classList.remove(styles.open);
      menuToggleButton.current.classList.remove(styles.open);
      setMenuOpen(false);
    }
  };
  return (
    <header className={styles.header} id="heading">
      <nav
        className={styles.nav}
        style={{ backgroundColor: props.bgColor || "transparent" }}
      >
        <Link to="/">
          <img
            src={`${process.env.PUBLIC_URL}/project_logo_row.png`}
            alt=""
            style={{
              width: "100%",
              height: "100%",
              imageRendering: "pixelated",
              objectFit: "contain",
            }}
          />
        </Link>
        <button
          className={styles.menu_toggle_button}
          onClick={onNavbarToggleButtonClick}
          aria-label="Open or close the menu"
          ref={menuToggleButton}
        >
          <svg
            width="86"
            height="55"
            viewBox="0 0 86 55"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: "100%", height: "100%" }}
          >
            <rect
              width="85.0213"
              height="10.5319"
              fill="white"
              className={styles.hamburger_menu_icon_top}
            />
            <rect
              y="22.234"
              width="85.0213"
              height="10.5319"
              fill="white"
              className={styles.hamburger_menu_icon_middle}
            />
            <rect
              y="44.468"
              width="85.0213"
              height="10.5319"
              fill="white"
              className={styles.hamburger_menu_icon_bottom}
            />
          </svg>
        </button>
      </nav>
      <div className={styles.menu_container} ref={menu}>
        <ul className={styles.menu_items}>
          <li className={styles.menu_item_li}>
            <Link to="/">HOME</Link>
          </li>
          <li className={styles.menu_item_li}>
            <Link to="/our-project">OUR PROJECT</Link>
          </li>
          <li className={styles.menu_item_li}>
            <Link to="/meet-the-team">MEET THE TEAM</Link>
          </li>
          <li className={styles.menu_item_li}>
            <Link to="/project-timeline">PROJECT TIMELINE</Link>
          </li>
          <li className={styles.menu_item_li}>
            <Link to="/gallery">GALLERY</Link>
          </li>
          <li className={styles.menu_item_li} style={{border: "2px dashed #fff", padding: ".5rem"}}>
            <Link to="/projectoutcomes">PROJECT OUTCOMES</Link>
          </li>
          <select className={styles.lang_select} disabled>
            <option value="en" defaultChecked>
              English
            </option>
            <option value="pt">Português</option>
            <option value="ro">Română</option>
            <option value="it">Italiano</option>
            <option value="tr">Türkçe</option>
          </select>
        </ul>

        <ul className={styles.credits}>
          <li>Credits:</li>
          <li>Ayça B | Beta Tester</li>
        </ul>
      </div>
    </header>
  );
}
